<template>
    <v-container fluid>
        <lead-form
            :model="model"
            @saved="saved"
            :isEdit="true"
            v-if="this.model"
        ></lead-form>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import Lead from '@/models/Lead'
import Form from './Form'

export default {
    props: ['id'],

    data: () => {
        return {
            model: null,
        }
    },

    components: {
        'lead-form': Form,
    },

    methods: {
        async getModel() {
            let model = new Lead()

            let res = await model.find(this.id)

            if (!res) return

            this.model = res
        },

        saved() {
            this.$router.push({ name: 'lead.index' })
        },
    },

    created() {
        this.getModel()
    },
}
</script>
